export const EVENTS = {
  CONTROLLER_OF_SAVE_AND_RELEASE_ACTION: 'controllerOfSaveAndReleaseAction',
};
